/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_ServiceInputs */

const vi_carrier_form_service = /** @type {(inputs: Carrier_Form_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dịch vụ vận chuyển`)
};

/**

* @param {Carrier_Form_ServiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_service = /** @type {((inputs?: Carrier_Form_ServiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_ServiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_service(inputs)
});